export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Scalar for BigDecimal */
  BigDecimal: { input: any; output: any; }
  /** Scalar for BigInteger */
  BigInteger: { input: any; output: any; }
  /** Scalar for DateTime */
  DateTime: { input: any; output: any; }
};

export type CourierResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type JobResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type OrderDetailsResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RestaurantOrderHistoryResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RestaurantOrderHistoryCouriersResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};



export type Address = {
  __typename?: 'Address';
  apartmentNumber?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  streetName: Scalars['String'];
  streetNumber: Scalars['String'];
};

export type Courier = {
  __typename?: 'Courier';
  pools: Pools;
};

export type CourierData = CourierResponse & {
  __typename?: 'CourierData';
  courier: Courier;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type CourierError = CourierResponse & {
  __typename?: 'CourierError';
  errorCode: CourierErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Customer = {
  __typename?: 'Customer';
  address: Address;
  lastName: Scalars['String'];
  location?: Maybe<Location>;
  phone?: Maybe<Scalars['String']>;
};

export type Job = {
  __typename?: 'Job';
  /** ISO-8601 */
  createdAt: Scalars['DateTime'];
  /** ISO-8601 */
  deliveredAt?: Maybe<Scalars['DateTime']>;
  order: Order;
  sequence: Scalars['Int'];
  status: JobStatus;
};

export type JobData = JobResponse & {
  __typename?: 'JobData';
  job: Job;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type JobError = JobResponse & {
  __typename?: 'JobError';
  errorCode: JobErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** A restaurant manager can assign an order to a courier. */
  assignOrder?: Maybe<JobResponse>;
  /**
   * A courier can claim an available order.
   * Calling with "courierId = 1" will throw a checked exception.
   * Calling with "orderHash = 1" will throw an unchecked exception.
   */
  claimOrder?: Maybe<JobResponse>;
  /** A restaurant manager can un-assign an order from a courier. It will mark the order as UNASSIGNED */
  unAssignOrder?: Maybe<UnassignResponse>;
  /**
   * A courier can un-claim an order. It will mark the order as UNASSIGNED
   * Calling with "courierId = 1" will return FAILURE.
   */
  unClaimOrder?: Maybe<UnassignResponse>;
};


/** Mutation root */
export type MutationAssignOrderArgs = {
  input: AssignOrderInput;
};


/** Mutation root */
export type MutationClaimOrderArgs = {
  input: AssignOrderInput;
};


/** Mutation root */
export type MutationUnAssignOrderArgs = {
  input: UnassignOrderInput;
};


/** Mutation root */
export type MutationUnClaimOrderArgs = {
  input: UnclaimOrderInput;
};

export type Order = {
  __typename?: 'Order';
  comment?: Maybe<Scalars['String']>;
  /** ISO-8601 */
  createdAt: Scalars['DateTime'];
  customer: Customer;
  /** ISO-8601 */
  expectedDeliveryTime?: Maybe<Scalars['DateTime']>;
  hasAlcohol: Scalars['Boolean'];
  hash: Scalars['String'];
  items: Array<Maybe<OrderItem>>;
  payment: Payment;
  platform: OrderPlatform;
  reference: Scalars['String'];
  restaurant: RestaurantInfo;
};

export type OrderDetailsData = OrderDetailsResponse & {
  __typename?: 'OrderDetailsData';
  job?: Maybe<Job>;
  order: Order;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RestaurantOrderHistoryData = RestaurantOrderHistoryResponse & {
  __typename?: 'RestaurantOrderHistoryData';
  items: Array<Maybe<RestaurantDeliveryRow>>;
  pageInfo: HistoryPageInfo;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RestaurantDeliveryRow = {
  __typename?: 'RestaurantDeliveryItem';
  node: Maybe<RestaurantDelivery>;
  cursor: Scalars['String'];
}

export type HistoryPageInfo = {
  __typename?: 'HistoryPageInfo';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
};

export type RestaurantDelivery = {
  __typename?: 'RestaurantDelivery';
  courier: RestaurantOrderHistoryCourier;
  /** ISO-8601 */
  deliveredAt: Scalars['DateTime'];
  hash: Scalars['String'];
  paymentMethod: DeliveryPaymentMethod;
  price: Payment;
  reference: Scalars['String'];
  tip:Scalars['String'];
  vehicleType: VehicleType;
};

export type RestaurantOrderHistoryCourier = {
  __typename?: 'RestaurantOrderHistoryCourier';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  type: CourierType;
};

export type RestaurantOrderSummaryResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
}


export type RestaurantOrderSummary = {
  __typename?: 'RestaurantOrderSummary',
  cashPaymentAmount: Scalars['Float'];
  deliveredOrders: Scalars['Int'];
  onlinePaymentAmount: Scalars['Float'];
  tipAmount: Scalars['Float'];
  currencyCode: Scalars['String']
}

export type RestaurantOrderHistoryError = RestaurantOrderHistoryResponse & {
  __typename?: 'RestaurantOrderHistoryError';
  errorCode: RestaurantOrderHistoryErrorCode;
    /** ISO-8601 */
    timestamp?: Maybe<Scalars['DateTime']>;
}

export type RestaurantOrderSummaryData = RestaurantOrderSummaryResponse & {
  __typename?: 'RestaurantOrderSummaryData';
  summary: RestaurantOrderSummary;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};



export type RestaurantOrderSummaryError = RestaurantOrderSummaryResponse & {
  __typename?: 'RestaurantOrderSummaryError';
  errorCode: RestaurantOrderSummaryErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RestaurantOrderHistoryCouriersData = RestaurantOrderHistoryCouriersResponse & {
  __typename?: 'RestaurantOrderHistoryCouriersData';
  couriers: Array<Maybe<RestaurantOrderHistoryCourier>>;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type RestaurantOrderHistoryCouriersError = RestaurantOrderHistoryCouriersResponse & {
  __typename?: 'RestaurantOrderHistoryCouriersError';
  errorCode: RestaurantOrderHistoryErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};


export type OrderDetailsError = OrderDetailsResponse & {
  __typename?: 'OrderDetailsError';
  errorCode: OrderDetailsErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  additions?: Maybe<Array<Maybe<OrderItemAddition>>>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type OrderItemAddition = {
  __typename?: 'OrderItemAddition';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  currencyCode: Scalars['String'];
  status: PaymentStatus;
  totalAmount: Scalars['Float'];
};

export type Pool = {
  __typename?: 'Pool';
  id: Scalars['String'];
  jobs: Array<Maybe<Job>>;
  status: PoolStatus;
  type: PoolType;
};

export type Pools = {
  __typename?: 'Pools';
  currentPool: Pool;
  nextPool: Pool;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  /** Gets courier */
  courier?: Maybe<CourierResponse>;
  /** Gets specific order's details */
  orderDetails?: Maybe<OrderDetailsResponse>;
  /** Gets couriers for the restaurant. */
  couriers?: Maybe<RestaurantOrderHistoryCouriersResponse>;
  /* "Gets orders history" */
  deliveryHistory?: Maybe<RestaurantOrderHistoryResponse>;
  summary?: Maybe<RestaurantOrderSummaryResponse>;
  
};


/** Query root */
export type QueryOrderDetailsArgs = {
  input: OrderDetailsInput;
};

export type QueryDeliveryHistoryArgs = {
  input: RestaurantOrderHistoryInput;
};

export type QueryOrderSummaryArgs ={
  input: RestaurantOrderSummaryInput;
};

export type QueryCouriersArgs = {
  input: RestaurantOrderHistoryCouriersInput;
};

export type RestaurantInfo = {
  __typename?: 'RestaurantInfo';
  id: Scalars['String'];
  location?: Maybe<Location>;
};

export type UnassignResponse = {
  __typename?: 'UnassignResponse';
  result: MutationResponse;
};

export enum CourierErrorCode {
  CourierNotFound = 'COURIER_NOT_FOUND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unknown = 'UNKNOWN'
}

export enum JobErrorCode {
  AssignedToOtherCourier = 'ASSIGNED_TO_OTHER_COURIER',
  CourierNotFound = 'COURIER_NOT_FOUND',
  ForbiddenByRestaurant = 'FORBIDDEN_BY_RESTAURANT',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidOrderStatus = 'INVALID_ORDER_STATUS',
  OrderAssignmentTimeExpired = 'ORDER_ASSIGNMENT_TIME_EXPIRED',
  OrderNotFound = 'ORDER_NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export enum JobStatus {
  Delivered = 'DELIVERED',
  InDelivery = 'IN_DELIVERY',
  ReadyForDelivery = 'READY_FOR_DELIVERY'
}

export enum MutationResponse {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum OrderDetailsErrorCode {
  AssignedToOtherCourier = 'ASSIGNED_TO_OTHER_COURIER',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  OrderNotFound = 'ORDER_NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export enum OrderPlatform {
  Takeaway = 'TAKEAWAY'
}

export enum PaymentStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum PoolStatus {
  InDelivery = 'IN_DELIVERY',
  Pending = 'PENDING'
}

export enum PoolType {
  Current = 'CURRENT',
  Next = 'NEXT'
}

export type AssignOrderInput = {
  courierId: Scalars['String'];
  orderHash: Scalars['String'];
};
 
export type OrderDetailsInput = {
  orderHash: Scalars['String'];
};

export type UnassignOrderInput = {
  courierId: Scalars['String'];
  orderHash: Scalars['String'];
};

export type UnclaimOrderInput = {
  courierId: Scalars['String'];
  orderHash: Scalars['String'];
};

export type HistoryInput = {
  dateBegin: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
};

export type HistoryResponse = {
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type HistoryData = HistoryResponse & {
  __typename?: 'HistoryData';
  delivery?: Maybe<Array<Delivery>>;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Delivery = {
  __typename?: 'Delivery';
  date: Scalars['DateTime'];
  hash: Scalars['String'];
  reference: Scalars['String'];
  paymentMethod: DeliveryPaymentMethod;
  price: Money;
  tip: Money;
  courier: HistoryCourier;
  vehicleType: VehicleType;
};

export enum DeliveryPaymentMethod {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
  Unknown = 'UNKNOWN'
}

export type HistoryCourier = {
  __typename?: 'HistoryCourier';
  id: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  type: CourierType;
};

export enum CourierType {
  Guest = 'GUEST',
  Registered = 'REGISTERED'
}

export enum VehicleType {
  Bike = 'BIKE',
  Ebike = 'EBIKE',
  Scooter = 'SCOOTER',
  Car = 'CAR',
  Unknown = 'UNKNOWN'
}

export type Money = {
  __typename?: 'Money';
  currencyCode: Scalars['String'];
  totalAmount: Scalars['Int'];
};

export type HistoryError = HistoryResponse & {
  __typename?: 'HistoryError';
  errorCode: HistoryErrorCode;
  /** ISO-8601 */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export enum HistoryErrorCode {
  RestaurantNotFound = 'RESTAURANT_NOT_FOUND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unknown = 'UNKNOWN'
}

/* Order Hsitory Input */

export enum PaymentType {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}


export enum RestaurantOrderHistoryErrorCode {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unknown = 'UNKNOWN'
}

export enum RestaurantOrderSummaryErrorCode {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unknown = 'UNKNOWN',
  InvalidTimeRange = 'INVALID_TIME_RANGE'
}


export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum TipStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type RestaurantOrderHistoryFilter = {
  courierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentType?: InputMaybe<PaymentType>;
  tipStatus?: InputMaybe<TipStatus>;
};

export type RestaurantOrderHistoryInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  dateBegin: Scalars['DateTime']['input'];
  /** ISO-8601 */
  dateEnd: Scalars['DateTime']['input'];
  filter?: InputMaybe<RestaurantOrderHistoryFilter>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<RestaurantOrderHistorySort>;
};

export type RestaurantOrderHistoryCouriersInput = {
  /** ISO-8601 */
  dateBegin: Scalars['DateTime']['input'];
  /** ISO-8601 */
  dateEnd: Scalars['DateTime']['input'];
};



export type RestaurantOrderHistorySort = {
  deliveredAt?: InputMaybe<SortDirection>;
};

export type RestaurantOrderSummaryInput = {
  /** ISO-8601 */
    /** ISO-8601 */
    dateBegin: Scalars['DateTime']['input'];
    /** ISO-8601 */
    dateEnd: Scalars['DateTime']['input'];
}